import React, { Component } from 'react'
import CacheKeys from '../../../cache/CacheKeys'
import CacheManager from '../../../cache/CacheManager'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import LoanTypeListPageUI from './LoanTypeListPageUI.js'

class LoanTypeListPageSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      loanTypeList: null
    }
  }

  render() {
    return (
      <LoanTypeListPageUI
        context={this.props.context}
        loanTypeList={this.state.loanTypeList}
        onRefreshClick={this.onRefreshClick}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getLoanTypes(context)
  }

  getLoanTypes(context) {
    let cacheManager = new CacheManager({
      resource: `/api/loanTypes`,
      cacheKey: CacheKeys.LoanTypes(),
      callback: this.getLoanTypesCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context)
  }

  getLoanTypesCallback = (response) => {
    this.setState({loanTypeList : response.loanTypeList})
  }

  onRefreshClick = () => {
    CacheManager.removeObject(CacheKeys.LoanTypes())
    this.setState({loanTypeList: null},
      this.getLoanTypes(this.props.context)
    )
  }
}

export default LoanTypeListPageSF
